import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import Error404 from "../components/errors/Error404";
import { Button, Card, Col } from "reactstrap";
import errorLottie from "../../src/assets/img/animated-icons/error-404.json";
import LottieAnimation from "../components/common/Animation/LottieAnimation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation } from "react-router-dom";
import AppContext from "../context/Context";
import { faHome } from "@fortawesome/free-solid-svg-icons";

const ErrorLayout = () => {
  const location = useLocation();
  const errorMessage =
    "Oops! Something went wrong. The page you are looking for isn't here.";
  const { loginUserDetails } = useContext(AppContext);
  let additionalScss = "";
  if(!location.pathname.startsWith(`${process.env.PUBLIC_URL}/admin`)){
    additionalScss += "error-container"; 
  }
  useEffect(()=>{
  if(localStorage.getItem("isLoggedIn") === "false")
  {
    window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
  }
  },[])
  const handleHomeRouter = () => {
    if (loginUserDetails.is_partner === "0")
      return `${process.env.PUBLIC_URL}/admin/dashboard`;
    else if (loginUserDetails.is_partner === "1")
      if (loginUserDetails.is_verified === "no") {
        return `${process.env.PUBLIC_URL}/authentication/login`;
      }
      else if (loginUserDetails.nda_status.toLowerCase() === "sent") 
        {
        return `${process.env.PUBLIC_URL}/user/sign-nda`;
      } else {
        return `${process.env.PUBLIC_URL}/user/applications`;
      }
    else {
      return `${process.env.PUBLIC_URL}`;
    }
  };
  return (
    <>
      <Card className={`text-center p-5 w-100 ${additionalScss}`}>
        <Col className="d-flex w-100 flex-column flex-center p-2">
          <LottieAnimation lotti={errorLottie} width={"40vh"} height={"40vh"} />
          <span className="border-top w-75 pl-4 pr-4 mb-4 " />
          <span className="font-weight-bold fs-1 p-1 pt-2 pb-5">{errorMessage}</span>
          <Link className="btn btn-primary btn-sm mt-3" to={handleHomeRouter}>
            <FontAwesomeIcon icon={faHome} className="mr-2" />
            Take me home
          </Link>
        </Col>
      </Card>
      {/* <Error404 /> */}
      {/* <Section className="py-0">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5">
          <Logo />
          <Switch>
            <Route path={`${process.env.PUBLIC_URL}`} component={Error404} />
            <Route path={`${process.env.PUBLIC_URL}/errors/500`} component={Error500} />
          </Switch>
        </Col>
      </Row>
    </Section> */}
    </>
  );
};

ErrorLayout.propTypes = { match: PropTypes.object };
export default ErrorLayout;
